
document.addEventListener('DOMContentLoaded', function() {
    function reindexGridElements() {  
        const collectionContainer = document.querySelector('[js-collection-main-section]');
        const allDesktopImageElements = Array.from(collectionContainer.querySelectorAll('[js-data-grid-container]'));
        const collectionGrids         = Array.from(collectionContainer.querySelectorAll('product-item'))
        console.log(allDesktopImageElements)

        if(allDesktopImageElements) {
            allDesktopImageElements.map((desktopImageElement, index) => {
                const currentElementIndex = Number(desktopImageElement.dataset.gridPosition)
                if(collectionGrids.length > currentElementIndex ) {
                    if(collectionGrids[currentElementIndex - 1]) {
                        collectionGrids[0].closest('product-list .product-list__inner').insertBefore(desktopImageElement,collectionGrids[currentElementIndex - 1].closest('product-item') )
                        // collectionGrids[currentElementIndex - 1].closest('.grid__item').prepend(desktopImageElement)
                    } 
                } else {
                    if(index == 0) {
                        collectionGrids[0].closest('product-list .product-list__inner').appendChild(desktopImageElement)
                    } else {
                        desktopImageElement.remove()
                    }
                }

                // in case if currentElementIndex goes larger than total grid items
                // then only show one on last
            })
        }
    }
    reindexGridElements()
    document.addEventListener('reindexGridElements:collection', reindexGridElements)
})